var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWireTransfersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 64,
    viewBox: "0 0 55 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2375_3985)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2375_3985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7377 30.3452H6.91797C9.20798 34.1033 12.674 37 16.7787 38.5862V35.9273C15.4729 34.2413 14.4462 32.3568 13.7377 30.3452Z",
    fill: "url(#paint0_linear_2375_3985)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_2375_3985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9638 8.06063e-07C18.4729 -0.00155888 13.2237 2.26038 9.45397 6.2528C8.30838 7.45883 7.3207 8.80601 6.51512 10.2616C6.49368 10.3006 6.47457 10.3415 6.45312 10.3813H13.4546C15.4904 4.19401 19.4344 8.06063e-07 23.9638 8.06063e-07Z",
    fill: "url(#paint1_linear_2375_3985)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_2375_3985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4549 10.3813H6.45342C4.83914 13.3171 3.99495 16.6139 4.00002 19.9641H11.9856C11.9673 16.7125 12.4633 13.4781 13.4549 10.3813Z",
    fill: "url(#paint2_linear_2375_3985)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_2375_3985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9856 19.9639H4.00001C3.99572 23.6272 5.00523 27.2199 6.91624 30.3452H13.736C12.553 27.0129 11.9607 23.4997 11.9856 19.9639Z",
    fill: "url(#paint3_linear_2375_3985)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_2375_3985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4531 10.3813H23.9623V0C19.433 0 15.4889 4.19401 13.4531 10.3813Z",
    fill: "url(#paint4_linear_2375_3985)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_2375_3985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9648 19.9639V25.5538H35.4641C35.7853 23.7079 35.9456 21.8374 35.9433 19.9639H23.9648Z",
    fill: "url(#paint5_linear_2375_3985)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_2375_3985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4609 25.5538H43.1272C43.6583 23.7379 43.9269 21.8558 43.9258 19.9639H35.9402C35.9425 21.8374 35.7822 23.7079 35.4609 25.5538Z",
    fill: "url(#paint6_linear_2375_3985)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_2375_3985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7754 35.9273V30.3452H13.7344C14.4429 32.3568 15.4695 34.2413 16.7754 35.9273Z",
    fill: "url(#paint7_linear_2375_3985)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_2375_3985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9648 2.31814e-06C28.4942 2.31814e-06 32.4383 4.19401 34.474 10.3813H41.4821C37.981 3.9776 31.263 -0.00350698 23.9648 2.31814e-06Z",
    fill: "url(#paint8_linear_2375_3985)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_i_2375_3985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4807 10.3813H34.4727C35.4642 13.4781 35.9602 16.7125 35.9419 19.9641H43.9275C43.9322 16.6147 43.0903 13.3186 41.4807 10.3813Z",
    fill: "url(#paint9_linear_2375_3985)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_2375_3985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.474 10.3813C32.4383 4.19401 28.4942 0 23.9648 0V10.3813H34.474Z",
    fill: "url(#paint10_linear_2375_3985)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_2375_3985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9633 10.3813H13.4541C12.4625 13.4781 11.9665 16.7125 11.9849 19.9641H23.9633V10.3813Z",
    fill: "url(#paint11_linear_2375_3985)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_i_2375_3985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9851 19.9639C11.9602 23.4997 12.5525 27.0129 13.7355 30.3452H16.7765V28.748C16.7765 26.984 18.2067 25.5538 19.9707 25.5538H23.9636V19.9639H11.9851Z",
    fill: "url(#paint12_linear_2375_3985)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_i_2375_3985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9433 19.9641C35.9616 16.7125 35.4656 13.4781 34.474 10.3813H23.9648V19.9641H35.9433Z",
    fill: "url(#paint13_linear_2375_3985)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_2375_3985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0054 49.9023L26.957 52.9046H39.0333L37.985 49.9023H28.0054Z",
    fill: "url(#paint14_linear_2375_3985)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4133 46.2155V26.665C50.4133 25.7934 49.7068 25.0869 48.8353 25.0869H17.1601C16.2885 25.0869 15.582 25.7934 15.582 26.665V46.2155H50.4133Z",
    fill: "url(#paint15_linear_2375_3985)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_di_2375_3985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4062 26.9126H48.5867V46.2159H17.4062V26.9126Z",
    fill: "url(#paint16_linear_2375_3985)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.582 45.4756V48.5272C15.582 49.3989 16.2887 50.1056 17.1605 50.1056H48.8354C49.7069 50.1056 50.4134 49.3991 50.4134 48.5276C50.4134 48.5275 50.4134 48.5273 50.4134 48.5272V45.4756H15.582Z",
    fill: "url(#paint17_linear_2375_3985)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0611 52.6958H25.9289C25.2493 52.6958 24.6992 53.3704 24.6992 55.0261H41.2908C41.2908 53.3703 40.7403 52.6958 40.0611 52.6958Z",
    fill: "url(#paint18_linear_2375_3985)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9995 48.4501C33.3638 48.4501 33.6591 48.1548 33.6591 47.7905C33.6591 47.4262 33.3638 47.1309 32.9995 47.1309C32.6352 47.1309 32.3398 47.4262 32.3398 47.7905C32.3398 48.1548 32.6352 48.4501 32.9995 48.4501Z",
    fill: "#21232B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.9188 26.9155L31.5037 45.4768H30.7148L39.13 26.9155H39.9188Z",
    fill: "#EEEFEE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37.4661 26.9155L29.0505 45.4768H25.6094L34.0245 26.9155H37.4661Z",
    fill: "#EEEFEE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2375_3985",
    x: 0,
    y: 0,
    width: 54.4141,
    height: 63.0259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.545098 0 0 0 0 0.996078 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2375_3985"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2375_3985",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2375_3985",
    x: 6.91797,
    y: 30.3452,
    width: 9.85938,
    height: 9.24121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2375_3985"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_2375_3985",
    x: 6.45312,
    y: 0,
    width: 17.5117,
    height: 11.3813,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2375_3985"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_2375_3985",
    x: 4,
    y: 10.3813,
    width: 9.45312,
    height: 10.5825,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2375_3985"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_2375_3985",
    x: 4,
    y: 19.9639,
    width: 9.73438,
    height: 11.3813,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2375_3985"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_2375_3985",
    x: 13.4531,
    y: 0,
    width: 10.5078,
    height: 11.3813,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2375_3985"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_2375_3985",
    x: 23.9648,
    y: 19.9639,
    width: 11.9766,
    height: 6.58984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2375_3985"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_2375_3985",
    x: 35.4609,
    y: 19.9639,
    width: 8.46484,
    height: 6.58984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2375_3985"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_2375_3985",
    x: 13.7344,
    y: 30.3452,
    width: 3.03906,
    height: 6.58203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2375_3985"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_2375_3985",
    x: 23.9648,
    y: 0,
    width: 17.5156,
    height: 11.3813,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2375_3985"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_2375_3985",
    x: 34.4727,
    y: 10.3813,
    width: 9.45312,
    height: 10.5825,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2375_3985"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_2375_3985",
    x: 23.9648,
    y: 0,
    width: 10.5078,
    height: 11.3813,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2375_3985"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_2375_3985",
    x: 11.9844,
    y: 10.3813,
    width: 11.9805,
    height: 10.5825,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2375_3985"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_2375_3985",
    x: 11.9844,
    y: 19.9639,
    width: 11.9805,
    height: 11.3813,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2375_3985"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_i_2375_3985",
    x: 23.9648,
    y: 10.3813,
    width: 11.9805,
    height: 10.5825,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2375_3985"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_2375_3985",
    x: 13.082,
    y: 22.5869,
    width: 37.832,
    height: 32.939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2375_3985"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2375_3985",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_di_2375_3985",
    x: 13.7556,
    y: 26.9126,
    width: 38.481,
    height: 26.6046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.65067
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.82534
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.55417 0 0 0 0 0.623252 0 0 0 0 0.860433 0 0 0 0.73 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2375_3985"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2375_3985",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2375_3985"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2375_3985",
    x1: 14.6722,
    y1: 30.5617,
    x2: 5.01204,
    y2: 35.9131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2375_3985",
    x1: 20.223,
    y1: 0.272667,
    x2: 6.29687,
    y2: 11.1479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2375_3985",
    x1: 11.4351,
    y1: 10.633,
    x2: 1.41982,
    y2: 15.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2375_3985",
    x1: 11.6561,
    y1: 20.2365,
    x2: 1.16837,
    y2: 24.7903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2375_3985",
    x1: 21.7173,
    y1: 0.272666,
    x2: 10.6856,
    y2: 5.44297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2375_3985",
    x1: 33.3844,
    y1: 20.1107,
    x2: 25.6555,
    y2: 27.7784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2375_3985",
    x1: 42.1175,
    y1: 20.1107,
    x2: 34.8514,
    y2: 25.2048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2375_3985",
    x1: 16.1257,
    y1: 30.4918,
    x2: 12.4652,
    y2: 31.4151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2375_3985",
    x1: 37.74,
    y1: 0.272667,
    x2: 23.8125,
    y2: 11.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2375_3985",
    x1: 41.9077,
    y1: 10.633,
    x2: 31.8925,
    y2: 15.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2375_3985",
    x1: 32.229,
    y1: 0.272666,
    x2: 21.1973,
    y2: 5.44297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2375_3985",
    x1: 21.4043,
    y1: 10.633,
    x2: 9.9157,
    y2: 17.2819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2375_3985",
    x1: 21.4045,
    y1: 20.2365,
    x2: 9.47291,
    y2: 26.6108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2375_3985",
    x1: 33.3847,
    y1: 10.633,
    x2: 21.8962,
    y2: 17.2819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2375_3985",
    x1: 36.4535,
    y1: 49.9812,
    x2: 32.9931,
    y2: 56.4254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#7091F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#436AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#3E63F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3152DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2375_3985",
    x1: 42.9725,
    y1: 25.6419,
    x2: 14.7931,
    y2: 47.1492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#7091F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#436AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#3E63F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3152DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2375_3985",
    x1: 41.9257,
    y1: 27.4196,
    x2: 16.3236,
    y2: 46.5657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2375_3985",
    x1: 42.9725,
    y1: 45.5972,
    x2: 39.5763,
    y2: 57.4259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#7091F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#436AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#3E63F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3152DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2375_3985",
    x1: 37.7464,
    y1: 52.757,
    x2: 35.9562,
    y2: 58.6581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#7091F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#436AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#3E63F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3152DD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWireTransfersIcon);
export default __webpack_public_path__ + "static/media/wireTransfersIcon.1eca2fb30b1ad004acfda14a826e2c56.svg";
export { ForwardRef as ReactComponent };